import { memo } from 'react';

import { type BoardCustomFieldValue } from '@air/api/types';

import { PublicBoardCustomFieldDateInput } from '~/components/PublicBoard/PublicBoardCustomFieldDateInput';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';
import { canChangeBoardCustomFields } from '~/utils/permissions/boardPermissions';
import { PublicBoardPanelCustomFieldContainer } from './PublicBoardPanelCustomFieldContainer';

export type PublicBoardPanelCustomFieldDateInputProps = {
  field: BoardCustomFieldValue;
};

export const PublicBoardPanelCustomFieldDateInput = memo(({ field }: PublicBoardPanelCustomFieldDateInputProps) => {
  const boardId = useURLBoardIdSelector();
  const { permissions } = usePublicPermissions();
  const canEditCustomFields = canChangeBoardCustomFields(permissions);

  if (!boardId) {
    return null;
  }

  return (
    <PublicBoardPanelCustomFieldContainer field={field}>
      <PublicBoardCustomFieldDateInput
        field={field}
        trackingLocation="board-side-panel"
        canEditCustomFields={canEditCustomFields}
        boardId={boardId}
      />
    </PublicBoardPanelCustomFieldContainer>
  );
});

PublicBoardPanelCustomFieldDateInput.displayName = 'PublicBoardPanelCustomFieldDateInput';
